<template>
	<span v-if="params.node.rowPinned || !notes">{{ materialName }}</span>
	<span v-else class="flex w-full items-center justify-between gap-1.5 min-w-0">
		<span class="truncate">{{ materialName }}</span>
		<i v-tooltip.top="notes" class="pi pi-file-edit text-[#005744] cursor-default text-[0.95rem] leading-none shrink-0" aria-label="Material notes"></i>
	</span>
</template>

<script setup lang="ts">
import { computed } from "vue"

type MaterialResultWithNotes = {
	notes?: string | null
}

type MaterialNameCellRendererParams = {
	value?: string | null
	data?: MaterialResultWithNotes
	node: { rowPinned?: boolean }
}

const props = defineProps<{
	params: MaterialNameCellRendererParams
}>()

const materialName = computed(() => props.params.value ?? "")
const notes = computed(() => props.params.data?.notes?.trim() ?? "")
</script>
